import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LegalService, LegalDocument } from '../../services/legal.service';
import { MetaTagService } from '../../services/meta-tag.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConsentService } from '../../services/consent.service';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: false
})
export class TermsComponent implements OnInit {

  doc: LegalDocument | null = null;
  safeContent: SafeHtml | null = null;
  loading = true;
  error = false;
  /** SCRUM-124: set when showing an archived version (/terms?version=1.0). */
  archivedVersion: string | null = null;
  isArchivedOld = false;

  constructor(
    private legalService: LegalService,
    private sanitizer: DomSanitizer,
    private seo: MetaTagService,
    private route: ActivatedRoute,
    private consentService: ConsentService
  ) {}

  ngOnInit(): void {
    this.seo.update({
      title:       'תנאים והגבלות',
      description: `קראו את תנאי השימוש של ${this.seo.siteName} — הזכויות, האחריויות וכללי השימוש בפלטפורמה.`,
      keywords:    `תנאים והגבלות, ${this.seo.siteName}, תנאי שימוש, מדיניות`,
      url:         this.seo.pageUrl('/terms'),
      jsonLd: {
        '@context': 'https://schema.org',
        '@type':    'WebPage',
        'name':     `תנאים והגבלות — ${this.seo.siteName}`,
        'url':      this.seo.pageUrl('/terms'),
      }
    });
    // Re-load when only the query string changes (/terms?version=1.0 -> /terms
    // keeps this same component instance).
    this.route.queryParamMap.subscribe(params => this.load(params.get('version')));
  }

  load(version: string | null = this.archivedVersion): void {
    this.loading = true;
    this.error = false;
    this.archivedVersion = version;
    this.isArchivedOld = false;
    const source$: Observable<LegalDocument> = this.archivedVersion
      ? this.consentService.getTermsVersion(this.archivedVersion).pipe(map(v => {
          this.isArchivedOld = !v.isCurrent;
          return {id: 0, title: v.title, content: v.content, version: v.version,
                  effective_date: v.effective_date, updated_at: ''} as LegalDocument;
        }))
      : this.legalService.getTermsConditions();
    source$.subscribe({
      next: (data) => {
        this.doc = data;
        this.safeContent = this.sanitizer.bypassSecurityTrustHtml(data.content || '');
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
